import { Box, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

import { DASHBOARD_CONFIG } from './constants';

interface IMainProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
  noHeader?: boolean;
}

export const Main = ({ sx, noHeader, children }: IMainProps) => {
  return (
    <Box
      component="main"
      id="main"
      sx={{ pt: noHeader ? 0 : DASHBOARD_CONFIG.HEADER.DESKTOP_HEIGHT / 8, width: '100vw', height: '100vh', overflowX: 'hidden', ...sx }}
    >
      {children}
    </Box>
  );
};
